export function capitalize(value: string, prefix?: string): string;
export function capitalize(value: boolean, prefix?: string): string;
export function capitalize(value: number, prefix?: string): string;
export function capitalize(
    value: string | boolean | number | undefined,
    prefix?: string,
): string | false {
    switch (typeof value) {
        case 'boolean':
            return prefix || '';
        case 'number':
            return `${prefix}${value}`;
        case 'string':
            const capitalizedText: string = value.charAt(0).toUpperCase() + value.slice(1);
            if (prefix) {
                return `${prefix}${capitalizedText}`;
            } else {
                return capitalizedText;
            }
        default:
            return false;
    }
}
